export type MediaType = 'movie' | 'tv' | 'variety';

export interface Media {
  id: string;
  title: string;
  type: MediaType;
  cover: string;
  director: string;
  cast: string[];
  genres: string[];
  region: string;
  year: number;
  updateDate: string;
  description: string;
  rating: number;
  tags: string[];
  episodes: string;
}

export const TYPE_LABELS: Record<MediaType, string> = {
  movie: '电影',
  tv: '电视剧',
  variety: '综艺',
};

export const REGION_OPTIONS = ['全部', '中国', '美国', '韩国', '英国'];
export const YEAR_OPTIONS = ['全部', '2024', '2023', '2022'];
export const TAG_OPTIONS = [
  '全部',
  '科幻',
  '悬疑',
  '剧情',
  '动作',
  '爱情',
  '冒险',
  '古装',
  '都市',
  '历史',
  '犯罪',
  '奇幻',
  '真人秀',
  '音乐',
  '美食',
  '选秀',
  '喜剧',
  '纪录片',
];